(function () {
  // This file is loaded globally (layout/theme.liquid), but the Category Slider section
  // only exists on some templates (Home has two of them). Init each slider separately and
  // let Swiper's built-in navigation handle Next/Prev (one step per click).
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.category-slider').forEach((el) => {
    new Swiper(el, {
      slidesPerView: 5,
      spaceBetween: 20,
      watchOverflow: true,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 45,
        },
        375: {
          slidesPerView: 3,
          spaceBetween: 60,
        },
        768: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 20,
        }
      }
    });
  });
})();
